<template>
    <v-card class="elevation-1">
        <v-toolbar flat height="37" @click="upcomingEventsVisible=!upcomingEventsVisible" class="clickable">
            <span class="primary--text font-weight-bold">
                UPCOMING EVENTS
            </span>
            <v-spacer></v-spacer>
            <v-btn icon :title="upcomingEventsVisible ? 'Minimize' : 'Expand'">
                <v-icon>{{ upcomingEventsVisible ? 'expand_less' : 'expand_more' }}</v-icon>
            </v-btn>
        </v-toolbar>
        <v-data-table
            v-if="upcomingEventsVisible"
            :headers="headers"
            :loading="loading"
            :items="events_list_filtered"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="paginationSync"
        >
            <template v-slot:items="props">
                <tr>
                    <td>
                        <v-chip small class="user-chip-container">
                            {{ getDateCaption(props.item.transDate) }}
                        </v-chip>
                    </td>
                    <td>
                        <span v-if="props.item.eventType=='birthday'">Birthdays</span>
                        <span v-if="props.item.eventType=='timeoff'">Time Offs</span>
                        <span v-if="props.item.eventType=='holiday'">{{ props.item.holidayType }}</span>
                    </td>
                    <td>
                        <div v-if="props.item.eventType=='birthday'">
                            <v-chip small v-for="(item,index) in props.item.birthdayItems" :key="index" class="user-chip-container">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.userId)"></v-img>
                                </v-avatar>
                                {{item.firstName}} {{item.lastName}}
                            </v-chip>
                        </div>
                        <div v-if="props.item.eventType=='timeoff'">
                            <v-chip small v-for="(item,index) in props.item.ptoItems" :key="index" class="user-chip-container">
                                <v-avatar>
                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.userId)"></v-img>
                                </v-avatar>
                                {{item.firstName}} {{item.lastName}}
                            </v-chip>
                        </div>
                        <span v-if="props.item.eventType=='holiday'">{{ props.item.holiday }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table> 
    </v-card>
</template>

<script>

import teamApi from '@/api/team'
import awsS3Helper from '@/helpers/aws-s3'
import { getDefaultTeamId } from '@/helpers/team-selector'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort, getExpandCollapseVisibility, updateExpandCollapseVisibility } from '@/helpers/user-prefs'

export default {     
    name: 'UpcomingTeamEvents',
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            upcomingEventsVisible: getExpandCollapseVisibility(routeName, 'upcoming-team-events'),
            headers: [
                {text: 'Date',align: 'left',value: 'transDate', width: '20%', sortable:true},
                {text: 'Type',align: 'left',value: '', width: '40%', sortable:false},
                {text: 'Details',align: 'left',value: '', width: '40%', sortable:false},
            ],
            error: false,
            errorMessage: '',
            loading: false,
            selectedTeamId: null,
            events_list: []
        }
    },
    methods: {
        getDateCaption(date) {
            if (this.$moment(new Date()).format('MMM DD dd') == this.$moment(date).format('MMM DD dd'))
                return "Today"
            return this.$moment(date).format('MMM DD dd')
        },
        async getEvents(){
            try {
                this.loading = true
                this.selectedTeamId = await getDefaultTeamId()
                const stored = localStorage.getItem(`TeamEvents_${this.selectedTeamId}`)
                if (stored) {
                    this.events_list = JSON.parse(stored)
                }
                const response = await teamApi.getTeamEventsByMonthStartingToday()
                if (response && response.status == 200) {
                    this.events_list = response.data.items
                    localStorage.setItem(`TeamEvents_${this.selectedTeamId}`, JSON.stringify(this.events_list))
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        this.getEvents()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        upcomingEventsVisible(newVal) {
            updateExpandCollapseVisibility(this.$route.name, 'upcoming-team-events', newVal)
        },
    },
    computed: {
        events_list_filtered() {
            const today = this.$moment(new Date()).format('YYYY-MM-DD');

            // Step 1: filter by date range only
            const filtered = this.events_list.filter(x => x.transDate >= today);

            // Step 2: explode each item into separate event records
            const expanded = filtered.flatMap(item => {
                const events = [];

                if (item.withBirthDay) {
                    events.push({
                        ...item,
                        eventType: "birthday"
                    });
                }

                if (item.withPTO) {
                    events.push({
                        ...item,
                        eventType: "timeoff"
                    });
                }

                if (item.holiday) {
                    events.push({
                        ...item,
                        eventType: "holiday"
                    });
                }

                return events; // return 0–3 items
            });

            return expanded;
        },
    }
}
</script>